import { format } from "date-fns";
import React, { useCallback, useMemo } from "react";
import { Tab } from "react-bootstrap";
import ExcelHandlerForm from "../../components/ExcelHandlerForm";
import { useHttpClient } from "../../../../lib/http";
import { BASE_URL } from "../../../witadmin/request";
import { useProperty } from "../../../../components/property-provider";
import { createFileDownloadFromRawData } from "../../../../lib/supportFunctions";
import { CustomExtra, ExtraModalActionType } from "../types";
import { useModal } from "../hooks/modal.hook";

interface OneTimePromoCodeProps {
  extra: CustomExtra;
  isFromAgr: boolean;
  allowedChainInventoryLinesTickers: string[];
  handleOnBack: () => void;
}

export function OneTimePromoCodeTabPanel({
  extra,
  isFromAgr,
  allowedChainInventoryLinesTickers = [],
  handleOnBack
}: OneTimePromoCodeProps) {
  const property = useProperty();
  const { showModal } = useModal();

  const httpClient = useHttpClient(BASE_URL || "");

  const currentFilledChainPropertyTickers = useMemo(() => {
    return allowedChainInventoryLinesTickers.filter((_, index) => {
      const list = (extra.chainInventoryLinesList && extra.chainInventoryLinesList[index]) || [];
      return list.length > 0
    });
  }, [allowedChainInventoryLinesTickers, extra.chainInventoryLinesList])

  const handleExportInventoryLinesExcel = useCallback(async (onFinish: () => void) => {
    try {
      const response = await httpClient.get(
        `/api/backoffice/${property.ticker}/onetimepromocodes/${extra.ticker}`,
        {
          responseType: "blob",
        }
      );

      createFileDownloadFromRawData(
        response,
        `onetimepromocodes_${format(new Date(), "yyyyMMdd")}`,
        "application/vnd.openxmlformats",
        "xlsx"
      );
      onFinish();
    } catch (e) {
      await showModal(
        { type: ExtraModalActionType.ERROR_DOWNLOAD_ONE_TIME_PROMO_CODE_EXCEL },
        onFinish,
      );
    }
  }, [extra.ticker, httpClient, property.ticker, showModal]);

  const handleImportInventoryLinesExcel = useCallback(async (data: ArrayBuffer) => {
    const dataToSend = new FormData();
    dataToSend.append("file", new Blob([data]));
    if (currentFilledChainPropertyTickers.length > 0) {
      dataToSend.append("properties", currentFilledChainPropertyTickers.join(","));
    }

    try {
      await httpClient.post(
        `/api/backoffice/${property.ticker}/onetimepromocodes/${extra.ticker}/type/EXTRA`,
        dataToSend
      );
      await showModal({ type: ExtraModalActionType.SUCCESS_PROCESS_ONE_TIME_PROMO_CODE_EXCEL }, handleOnBack);
    } catch (e) {
      console.error(e);
      await showModal(
        { type: ExtraModalActionType.ERROR_PROCESS_ONE_TIME_PROMO_CODE_EXCEL },
        () => {}
      );
    }
  }, [currentFilledChainPropertyTickers, extra.ticker, handleOnBack, httpClient, property.ticker, showModal]);

  return (
    <Tab.Pane key="one-time-promo-code" eventKey="oneTimePromoCode">
      <ExcelHandlerForm
        isDisabled={isFromAgr}
        onExport={handleExportInventoryLinesExcel}
        onImport={handleImportInventoryLinesExcel}
      />
    </Tab.Pane>
  )
}